export default {
  switchAccount: "アカウント切り替え",
  login: "ログイン",
  loginFirst: "ログインしてください",
  start: "スタート",
  hasHistory: "一部の質問はすでに回答済みです。",
  loadHistory: "このまま進めますか？",
  cancel: "キャンセル",
  confirm: "確定",
  contact: "メールアドレスを入力すると確率で報酬を獲得できますよ！",
  completed: "アンケートにご参加いただき、ありがとうございます！",
  leaveMessage: "抽選に参加するため、メールアドレスを入力してください。",
  enterEmail: "メールアドレスを入力してください。",
  enterPhone: "",
  submit: "提出",
  leave: "アンケートに参加しない",
  submitted: "提出しました。",
  thanks: "ご参加ありがとうございます～",
  opinion: "ご入力ください",
  prev: "前へ",
  next: "次へ",
  unlikely: "可能性が非常に高い",
  likely: "可能性が非常に低い",
  claimYourRewards:
    "こちらは感謝ギフトを用意いたしますので。",
  rewardSent: "報酬を送信しました。",
  checkInGame: "ゲーム内でご確認ください。",
  copy: "コピー",
  copied: "コピー成功！",
  selectTips: "下記の選択肢から選んでください。",
  multipleTips: "下記の選択肢から選んでください。（複数選択可）",
  leastChoose: "最大xxx個まで選択可能",
  maxChoose: "最低でもxxx個選択",
  mustAnswer: "先にこの質問に回答してください。",
  mustWrite: "内容を入力してください。",
  checkEmail: "正しいメールアドレスを入力してください。",
  isAnswer: "解答済み",
  unStart: "イベント未解放",
  end: "イベント終了",
  checkPhone: "",
  server: "サーバー選択",
  role: "キャラクター選択",
  common: "システムエラー、再度お試しください",
  title: "アンケート",
  titleAward: "報酬付きアンケート",
  leastWord: "文字数はxxx文字以上でお願いします。",
  maxWord: "文字数はxxx文字以内でお願いします。",
  singleChoose: "単一選択",
  multiChoose: "複数選択",
  matrix: "マトリックス",
  score: "評価問題",
  textLimit: "(xx-yyy文字)",
  coverGiftTitle: "アンケート調査の参加で豪華報酬入手",
  "-20001": "ログインしていません",
  "-20002": "必要なパラメータが不足しています",
  "-20003": "アンケートが見つかりません",
  "-20004": "アンケート設定中",
  "-20005": "アンケートが停止されました",
  "-20006": "アンケートイベントが開始されていません",
  "-20007": "アンケートイベントが終了しました",
  "-20008": "既に回答済みです",
  "-20010": "報酬配布に失敗しました",
  "-20011": "このアンケートの報酬は既に配布されています",
  "-20012": "まだ回答していません",
  "-20016": "ゲームIDが無効です",
};
